import { IApiBaseErrorResponse } from '@app/api/interfaces/api-base-error-response.interface';
import { IDateRange } from '@app/core/date-range/interfaces/date-range.interface';
import { FpLoggerNoiseTabs } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/enums/fp-logger-noise-tabs.enum';
import { MonthsDateRangeType } from '@app/core/date-range/enums/months-date-range-type.enum';
import { ICombinedSpreadChartData } from '@app/main/leak-detection/floating-popups/floating-popup-logger-noise/tabs/fp-logger-noise-spread/interfaces/combined-spread-chart-data';
import { ILdLogger } from '@app/main/leak-detection/interfaces/ld-logger';

export interface IFpLoggerNoiseSpreadState {
  currentTab: FpLoggerNoiseTabs.Spread;
  date: string | null;
  period: MonthsDateRangeType;
  cache: {
    dateRange: IDateRange | null;
    data: ICombinedSpreadChartData[] | null;
  };
  popupMainData: ILdLogger | null;
  data: ICombinedSpreadChartData[] | null;
  loading: boolean;
  isChartFullscreenActive: boolean;
  error: IApiBaseErrorResponse | null;
}

export const initialFpLoggerNoiseSpreadState: IFpLoggerNoiseSpreadState = {
  currentTab: FpLoggerNoiseTabs.Spread,
  date: null,
  period: MonthsDateRangeType.Six,
  cache: {
    dateRange: null,
    data: null,
  },
  popupMainData: null,
  data: null,
  loading: false,
  isChartFullscreenActive: false,
  error: null,
};
